import instance from "./instance";
export const findAll = () => {
    return instance.get(`/banner`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
